import { useQuery } from '@apollo/client';
import { StaffProfileHeaderContainerStaffUserCurrentDocument } from '../../../../generated';
import { useOid } from '../../../../hooks/useOid';
import { ComponentQueryLoader } from '../../../shared/component-query-loader';
import { getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled } from '../../../shared/utils/queryOptions';
import { ProfileHeader } from './profile-header';

interface ProfileHeaderContainerProps {
  title: string;
  onEdit: () => void;
}

export const ProfileHeaderContainer: React.FC<ProfileHeaderContainerProps> = (props) => {
  const oid = useOid();
  const staffUserCurrentQueryOptions = getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled(oid);

  const { data, error, loading } = useQuery(StaffProfileHeaderContainerStaffUserCurrentDocument, staffUserCurrentQueryOptions);

  return (
    <ComponentQueryLoader
      loading={loading}
      hasData={data?.staffUserCurrent}
      error={error}
      hasDataComponent={
        <ProfileHeader
          title={props.title}
          onEdit={props.onEdit}
          disabled={!data?.staffUserCurrent?.role?.permissions?.applicantUserPermissions?.canUpdatePersonalInformation}
        />
      }
    />
  );
};
